/* yancha theme. the board 6 prototype's behaviour, wired to shopify's cart. */
(function(){
  const Y = window.Yancha || {};
  const R = Y.routes || {root:'/', cart:'/cart', cartAdd:'/cart/add', cartChange:'/cart/change'};
  const html = document.documentElement;
  const $ = id => document.getElementById(id);
  const clamp01 = x => Math.min(1, Math.max(0, x));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const navIn = html.classList.contains('nav-in');
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const pct = (was, now) => Math.round((1 - now / was) * 100);
  const sized = (url, w) => url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : '';
  const rootPath = (R.root || '/').replace(/\/$/, '');
  // every word comes from the theme's locale file (Online Store → Themes → Edit default theme content)
  const S = Y.strings || {};
  const tr = (k, vars) => String(S[k] || '').replace(/\[(\w+)\]/g, (m, n) => vars && n in vars ? vars[n] : m);

  /* ---------- money: the shop's own format, prices in pence ---------- */
  function money(cents){
    const fmt = String(Y.moneyFormat || '£{{amount}}').replace(/<[^>]*>/g, '');
    const n = (cents || 0) / 100;
    const num = (dec, ts, ds) => {
      const parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts[1] ? parts[0] + ds + parts[1] : parts[0];
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: num(2, ',', '.'),
      amount_no_decimals: num(0, ',', '.'),
      amount_with_comma_separator: num(2, '.', ','),
      amount_no_decimals_with_comma_separator: num(0, '.', ','),
      amount_with_apostrophe_separator: num(2, "'", '.'),
      amount_with_space_separator: num(2, ' ', ',')
    }[k] || num(2, ',', '.')));
  }
  const post = (url, body) => fetch(url, {
    method: 'POST',
    headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
    body: JSON.stringify(body)
  }).then(r => r.json().then(j => {
    if (!r.ok) throw new Error(j.description || j.message || tr('error'));
    return j;
  }));

  const logo = $('logo'), header = $('header');
  const isHome = () => document.body.dataset.route === 'home' && !!$('hero');

  /* ---------- the hands: rise into frame as the intro clears, sway, lean toward the pointer ---------- */
  const intro = $('intro'), introMark = $('introMark');
  const playIntro = !!intro && !reduce && !navIn && !Y.designMode;
  const INTRO_MS = playIntro ? 1250 : 0;
  let hands = [];
  function collectHands(){
    hands = [$('holdPouch'), $('holdTin')].filter(Boolean).map((el, i) => ({
      el, delay: INTRO_MS + 120 + i * 150, phase: i * 3.4,
      rot: 0, vrot: 0, lift: 0, vlift: 0
    }));
  }
  let ptrX = -9999, ptrY = -9999, handsT0 = 0, heroFade = 1;
  window.addEventListener('pointermove', e => { ptrX = e.clientX; ptrY = e.clientY; }, {passive:true});
  window.addEventListener('pointerleave', () => { ptrX = ptrY = -9999; });
  const easeBack = x => { const c = 1.7; return 1 + (c + 1) * Math.pow(x - 1, 3) + c * Math.pow(x - 1, 2); };
  function animateHands(now){
    if (!handsT0) handsT0 = now;
    const t = now - handsT0, y = window.scrollY;
    hands.forEach(h => {
      if (!h.el.isConnected) return;
      const p = clamp01((t - h.delay) / 900);
      const rise = (1 - easeBack(p)) * (h.el.offsetHeight * .8 + 120);
      const sway = Math.sin(now / 2800 + h.phase) * 5;
      const swayR = Math.sin(now / 3400 + h.phase) * 1.4;
      let tr = 0, tl = 0;
      if (p > .9 && ptrX > -9998){
        const r = h.el.getBoundingClientRect(), cx = r.left + r.width / 2;
        const dx = (ptrX - cx) / (window.innerWidth * .5);
        const near = clamp01(1 - Math.abs(ptrY - r.top) / 520);
        tr = Math.max(-1, Math.min(1, dx)) * 9 * near;
        tl = -26 * near;
      }
      h.vrot += (tr - h.rot) * .08; h.vrot *= .84; h.rot += h.vrot;
      h.vlift += (tl - h.lift) * .08; h.vlift *= .84; h.lift += h.vlift;
      h.el.style.transformOrigin = '50% 100%';
      h.el.style.opacity = heroFade.toFixed(3);
      h.el.style.transform =
        `translate3d(${sway.toFixed(1)}px, ${(rise + h.lift + y * .28).toFixed(1)}px, 0) rotate(${(swayR + h.rot).toFixed(2)}deg)`;
    });
    requestAnimationFrame(animateHands);
  }

  /* ---------- marquees ---------- */
  // separator: the brand star, always honey
  const sep = c => `<i class="sepstar" style="--sc:${c}" aria-hidden="true"></i>`;
  let paused = false;
  const marquees = () => [...document.querySelectorAll('[data-marquee]')];
  const pauseIcon = '<svg viewBox="0 0 12 12"><rect x="1" y="1" width="3.5" height="10" fill="currentColor"/><rect x="7.5" y="1" width="3.5" height="10" fill="currentColor"/></svg>';
  const playIcon = '<svg viewBox="0 0 12 12"><path d="M2 1l9 5-9 5z" fill="currentColor"/></svg>';
  function buildMarquees(){
    marquees().forEach(m => {
      const phrases = m.dataset.marquee.split('|').filter(Boolean);
      if (!phrases.length) return;
      const col = getComputedStyle(html).getPropertyValue('--honey').trim() || '#FFD24A';
      const unit = phrases.map(p => `<span>${esc(p)}</span>${sep(col)}`).join('');
      let track = m.querySelector('.track');
      if (!track){
        track = document.createElement('div');
        track.className = 'track';
        track.setAttribute('aria-hidden','true');
        m.insertBefore(track, m.firstChild);
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mq-pause';
        btn.setAttribute('aria-label', paused ? tr('play') : tr('pause'));
        btn.setAttribute('aria-pressed', String(paused));
        btn.innerHTML = paused ? playIcon : pauseIcon;
        btn.addEventListener('click', togglePause);
        m.appendChild(btn);
        m.classList.toggle('paused', paused);
      }
      track.innerHTML = `<div class="group">${unit}</div>`;
      const w = track.firstChild.scrollWidth || 1;
      const reps = Math.max(1, Math.ceil(window.innerWidth / w));
      const group = `<div class="group">${unit.repeat(reps)}</div>`;
      track.innerHTML = group + group;
    });
  }
  function togglePause(){
    paused = !paused;
    marquees().forEach(m => {
      m.classList.toggle('paused', paused);
      const b = m.querySelector('.mq-pause');
      if (!b) return;
      b.setAttribute('aria-pressed', String(paused));
      b.setAttribute('aria-label', paused ? tr('play') : tr('pause'));
      b.innerHTML = paused ? playIcon : pauseIcon;
    });
  }

  /* ---------- logo docking ---------- */
  const ease = t => t < .5 ? 2*t*t : 1 - Math.pow(-2*t + 2, 2)/2;
  function layout(){
    if (!logo || !header) return;
    const home = isHome();
    const vh = window.innerHeight;
    const hh = header.offsetHeight;
    const bigW = logo.offsetWidth, bigH = bigW / 2.868;
    const endW = window.innerWidth < 420 ? 76 : 104;
    const endScale = Math.min(1, endW / bigW);
    const y = window.scrollY;
    let p;
    if (!home) p = 1;
    else if (reduce) p = y > vh * .35 ? 1 : 0;
    else p = Math.min(1, Math.max(0, y / (vh * .55)));
    const e = ease(p);
    const startY = vh * .44 - bigH/2;
    const endY = hh/2 - bigH/2;
    logo.style.transform = `translate(-50%, ${startY + (endY - startY) * e}px) scale(${1 + (endScale - 1) * e})`;
    header.classList.toggle('solid', !home || p >= 1);
    logo.classList.toggle('docked', !home || p >= 1);
    if (home){
      const fade = Math.max(0, 1 - p*2.2);
      heroFade = Math.max(0, 1 - p*1.7);
      const tagline = $('tagline'), noteHero = $('noteHero'), cue = $('scrollcue');
      if (tagline) tagline.style.opacity = String(fade);
      if (noteHero) noteHero.style.opacity = String(fade);
      if (cue){ cue.style.opacity = String(fade); cue.style.pointerEvents = fade < .05 ? 'none' : 'auto'; cue.setAttribute('aria-hidden', fade < .05 ? 'true' : 'false'); }
    }
  }
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking){ requestAnimationFrame(() => { layout(); ticking = false; }); ticking = true; }
  }, {passive:true});
  let rt, revResize = () => {};
  window.addEventListener('resize', () => { layout(); clearTimeout(rt); rt = setTimeout(() => { buildMarquees(); revResize(); }, 150); });

  /* ---------- menus ---------- */
  const menus = () => [...document.querySelectorAll('.menu')];
  function closeMenus(except){
    menus().forEach(m => {
      if (m === except) return;
      const b = m.querySelector('button'), ul = m.querySelector('ul');
      if (b) b.setAttribute('aria-expanded','false');
      if (ul) ul.classList.remove('open');
    });
  }
  function initMenus(){
    menus().forEach(m => {
      if (m.dataset.ready) return;
      m.dataset.ready = '1';
      const b = m.querySelector('button'), ul = m.querySelector('ul');
      if (!b || !ul) return;
      b.addEventListener('click', e => {
        e.stopPropagation();
        const open = b.getAttribute('aria-expanded') !== 'true';
        closeMenus(m);
        b.setAttribute('aria-expanded', String(open));
        ul.classList.toggle('open', open);
        const first = ul.querySelector('a');
        if (open && first) first.focus();
      });
      ul.addEventListener('click', () => closeMenus());
    });
  }
  document.addEventListener('click', () => closeMenus());

  /* ---------- page-change loader: five squares, then the next page ---------- */
  const loaderEl = $('loader');
  function scrollToEl(el, instant){
    const top = el.getBoundingClientRect().top + window.scrollY - (header ? header.offsetHeight : 0);
    window.scrollTo({top, behavior: instant || reduce ? 'auto' : 'smooth'});
  }
  function leaveTo(url){
    if (reduce || !loaderEl){ location.href = url; return; }
    html.classList.remove('nav-in');
    loaderEl.classList.remove('out', 'gone');
    loaderEl.classList.add('on');
    try { sessionStorage.setItem('yNav', '1'); } catch(e){}
    setTimeout(() => { location.href = url; }, 300);
  }
  document.addEventListener('click', e => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest('a[href]');
    if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download') || a.id === 'bagBtn') return;
    const href = a.getAttribute('href');
    if (!href || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) return;
    const url = new URL(a.href, location.href);
    if (url.origin !== location.origin) return;
    // same page with an anchor (e.g. "gum" while already home) is a scroll, not a page change
    if (url.pathname === location.pathname && url.search === location.search){
      if (url.hash){
        const t = document.getElementById(decodeURIComponent(url.hash.slice(1)));
        if (t){ e.preventDefault(); scrollToEl(t); history.replaceState(null, '', url.hash); }
      }
      return;
    }
    if (Y.designMode || /\/(checkout|account|cart\/|discount\/)/.test(url.pathname)) return;
    e.preventDefault();
    leaveTo(url.href);
  });
  if (navIn && loaderEl) setTimeout(() => loaderEl.classList.add('gone'), 80);
  window.addEventListener('pageshow', e => {
    if (!e.persisted || !loaderEl) return;
    loaderEl.classList.remove('on', 'out');
    loaderEl.classList.add('gone');
    Cart.refresh();
  });

  /* ---------- opening reveal ---------- */
  /* flat mint. the brush mark lands in black exactly where the hero's mark sits.
     then the field wipes upward on a wavy edge, so the mark seems to invert as the wave passes. */
  const easeOut3 = x => 1 - Math.pow(1 - x, 3);
  const easeInOut = x => x < .5 ? 4*x*x*x : 1 - Math.pow(-2*x + 2, 3) / 2;
  function wipeMask(w, h, edge, amp, len, ph){
    const yAt = x => (edge + amp * Math.sin(x / len * Math.PI * 2 + ph)).toFixed(1);
    let d = `M0 0H${w}V${yAt(w)}`;
    for (let x = w - 12; x > 0; x -= 12) d += `L${x} ${yAt(x)}`;
    d += `L0 ${yAt(0)}Z`;
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${w} ${h}" width="${w}" height="${h}" preserveAspectRatio="none">`
      + `<rect width="${w}" height="${h}" fill="black"/><path d="${d}" fill="white"/></svg>`;
    return `url("data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}")`;
  }
  function runIntro(){
    intro.classList.remove('boot');
    intro.classList.add('on');
    const r = logo.getBoundingClientRect();
    Object.assign(introMark.style, {left: r.left + 'px', top: r.top + 'px', width: r.width + 'px'});
    const T_FLAT = 140,   // a beat of flat colour
          T_LAND = 360,   // the mark slaps down
          T_HOLD = 420,   // the readable beat
          T_WIPE = 720;   // the field wipes up on a wavy edge
    const t0 = performance.now();
    (function step(now){
      const t = now - t0, w = innerWidth, h = innerHeight;
      const land = easeOut3(clamp01((t - T_FLAT) / T_LAND));
      introMark.style.opacity = String(Math.min(1, land * 4));
      introMark.style.transform = `scale(${(1.16 - .16 * land).toFixed(4)}) rotate(${(-4 * (1 - land)).toFixed(2)}deg)`;
      const wr = clamp01((t - T_FLAT - T_LAND - T_HOLD) / T_WIPE);
      if (wr > 0){
        const amp = Math.min(30, h * .04), len = Math.max(150, w / 7);
        const edge = (h + amp) - easeInOut(wr) * (h + amp * 3);
        intro.style.setProperty('--wipe', wipeMask(w, h, edge, amp, len, t / 240));
        intro.classList.add('masked');
      }
      if (wr < 1) requestAnimationFrame(step);
      else { intro.classList.remove('on', 'masked'); intro.style.removeProperty('--wipe'); }
    })(t0);
  }

  /* ---------- basket: shopify ajax cart ---------- */
  const Cart = (function(){
    const root = $('cartRoot'), dataEl = $('yCartData');
    const bagBtn = $('bagBtn');
    let state = null, lastFocus = null, code = '';
    try { code = sessionStorage.getItem('yCode') || ''; } catch(e){}
    const C = dataEl ? JSON.parse(dataEl.textContent) : {};
    const items = () => (state && state.items) || [];
    const hasSub = () => items().some(i => i.selling_plan_allocation);
    const onlySubs = () => items().length > 0 && items().every(i => i.selling_plan_allocation);

    function paintCount(){
      const count = state ? state.item_count : 0;
      const el = $('bagCount');
      if (el){ el.textContent = count; el.dataset.n = count; }
      if (bagBtn) bagBtn.setAttribute('aria-label', tr(count === 1 ? 'openOne' : 'openOther', {count}));
    }
    function render(){
      paintCount();
      if (!root) return;
      const list = items();
      $('dfoot').hidden = !list.length;
      if (!list.length){
        $('items').innerHTML = `<p class="empty">${esc(tr('empty'))}</p>`;
        $('upsell').innerHTML = ''; $('sum').innerHTML = '';
        return;
      }
      $('items').innerHTML = list.map((i, idx) => {
        const title = i.product_has_only_default_variant || !i.variant_title
          ? i.product_title : `${i.product_title}, ${i.variant_title}`;
        const plan = i.selling_plan_allocation && i.selling_plan_allocation.selling_plan;
        const sub = plan ? plan.name : tr('oneTime');
        const was = i.original_line_price > i.final_line_price ? `<s class="small">${money(i.original_line_price)}</s>` : '';
        const img = i.image ? sized(i.image, 160) : C.fallbackImage;
        return `<div class="item">
          <div class="thumb"><img class="shot" src="${esc(img)}" alt="" aria-hidden="true"></div>
          <div class="meta"><strong>${esc(title.toLowerCase())}</strong><small>${esc(sub.toLowerCase())}</small><span class="q"><button type="button" data-dec="${idx}" aria-label="${esc(tr('decrease'))}">−</button>${i.quantity}<button type="button" data-inc="${idx}" aria-label="${esc(tr('increase'))}">+</button></span></div>
          <div class="right">${was}<b>${money(i.final_line_price)}</b><button class="rm" type="button" data-rm="${idx}">${esc(tr('remove'))}</button></div>
        </div>`;
      }).join('');

      const U = C.upsell;
      const upsellIn = U && list.some(i => i.variant_id === U.id);
      if (U && U.available && !upsellIn){
        const subP = hasSub() && U.subPrice > 0 && U.subPrice < U.price;
        $('upsell').innerHTML = `<div class="upsell"><div class="mini"><img class="shot shot-tin" src="${esc(U.image)}" alt="" aria-hidden="true"></div><div class="u"><strong>${esc(U.title)}</strong><small>${subP ? esc(tr('upsellSub', {price: money(U.subPrice), percent: pct(U.price, U.subPrice)})) : money(U.price)}</small></div><button type="button" id="upAdd">${esc(tr('add'))}</button></div>`;
        $('upAdd').addEventListener('click', () => add([{id: U.id, quantity: 1}]));
      } else if (C.soon){
        $('upsell').innerHTML = `<div class="upsell"><div class="u"><strong>${esc(C.soon)}</strong><small>${esc(C.soonText || '')}</small></div></div>`;
      } else {
        $('upsell').innerHTML = '';
      }

      const subItem = list.find(i => i.selling_plan_allocation);
      const disc = state.total_discount || 0;
      const handNote = onlySubs() ? C.handNoteSubs : C.handNote;
      $('sum').innerHTML = `
        <div class="row"><span>${esc(tr('subtotal'))}</span><span>${money(state.items_subtotal_price)}</span></div>
        <div class="row"><span>${esc(tr('delivery'))}</span><span>${esc(C.delivery || tr('deliveryAtCheckout'))}</span></div>
        ${disc && state.total_price < state.items_subtotal_price ? `<div class="row"><span>${esc(tr('discounts'))}</span><span>−${money(state.items_subtotal_price - state.total_price)}</span></div>` : ''}
        <div class="row big"><span>${esc(tr('totalToday'))}</span><span>${money(state.total_price)}</span></div>
        ${subItem ? `<p class="small">${esc(tr('basketRenews', {plan: subItem.selling_plan_allocation.selling_plan.name.toLowerCase(), price: money(subItem.final_line_price)}))}</p>` : ''}
        ${handNote ? `<p class="small hand-note">${esc(handNote)}</p>` : ''}`;
    }
    function refresh(){
      return fetch(R.cart + '.js', {headers: {'Accept': 'application/json'}})
        .then(r => r.json()).then(c => { state = c; render(); return c; })
        .catch(() => state);
    }
    function add(lines){
      return post(R.cartAdd + '.js', {items: lines}).then(refresh);
    }
    function change(key, quantity){
      if (root) root.querySelectorAll('.item button').forEach(b => b.disabled = true);
      return post(R.cartChange + '.js', {id: key, quantity})
        .then(c => { state = c; render(); })
        .catch(err => { $('status').textContent = err.message; refresh(); });
    }
    function open(){
      if (!root){ location.href = R.cart; return Promise.resolve(); }
      lastFocus = document.activeElement;
      $('status').textContent = '';
      root.classList.add('cart-open');
      setTimeout(() => root.querySelector('.x').focus(), 60);
      return refresh();
    }
    function close(){
      if (!root) return;
      root.classList.remove('cart-open');
      if (lastFocus) lastFocus.focus();
    }

    if (bagBtn) bagBtn.addEventListener('click', e => { if (!root) return; e.preventDefault(); open(); });
    if (root){
      root.querySelectorAll('[data-close]').forEach(b => b.addEventListener('click', close));
      $('items').addEventListener('click', e => {
        const t = e.target.closest('button');
        if (!t) return;
        const list = items();
        if (t.dataset.rm !== undefined){ change(list[+t.dataset.rm].key, 0); }
        else if (t.dataset.inc !== undefined){ const i = list[+t.dataset.inc]; change(i.key, i.quantity + 1); }
        else if (t.dataset.dec !== undefined){ const i = list[+t.dataset.dec]; change(i.key, i.quantity - 1); }
      });

      /* discount code: saved here, checked and applied by shopify at checkout */
      const codeForm = $('codeForm'), codeToggle = $('codeToggle'), codeMsg = $('codeMsg'), codeIn = $('codeIn');
      codeToggle.addEventListener('click', () => {
        const opening = codeForm.hidden;
        codeForm.hidden = !opening;
        codeToggle.setAttribute('aria-expanded', String(opening));
        if (opening) codeIn.focus();
      });
      const saveCode = v => { code = v; try { v ? sessionStorage.setItem('yCode', v) : sessionStorage.removeItem('yCode'); } catch(e){} };
      function showCode(){
        codeMsg.textContent = '';
        if (!code) return;
        const b = document.createElement('b'); b.textContent = code;
        const rm = document.createElement('button'); rm.type = 'button'; rm.className = 'linkbtn'; rm.textContent = tr('codeRemove');
        rm.addEventListener('click', () => { saveCode(''); showCode(); codeIn.focus(); });
        codeMsg.append(b, ' ' + tr('codeSaved') + ' ', rm);
      }
      function applyCode(){
        const v = codeIn.value.trim().toUpperCase().replace(/\s+/g, '');
        if (!v){ codeMsg.textContent = tr('codeEmpty'); return; }
        saveCode(v); codeIn.value = ''; showCode();
      }
      $('codeApply').addEventListener('click', applyCode);
      codeIn.addEventListener('keydown', e => { if (e.key === 'Enter'){ e.preventDefault(); applyCode(); } });
      // a code won in the welcome game lands here too
      document.addEventListener('yancha:code', e => { saveCode(String(e.detail || '')); showCode(); });
      showCode();

      $('checkoutBtn').addEventListener('click', () => {
        const btn = $('checkoutBtn');
        btn.setAttribute('aria-busy', 'true');
        location.href = code
          ? `${rootPath}/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(rootPath + '/checkout')}`
          : `${rootPath}/checkout`;
      });
    }
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape') return;
      if (root && root.classList.contains('cart-open')) close(); else closeMenus();
    });

    // any "add to basket" button on the page: <button data-add-variant="123">
    document.addEventListener('click', e => {
      const b = e.target.closest('[data-add-variant]');
      if (!b) return;
      e.preventDefault();
      b.setAttribute('aria-busy', 'true');
      add([{id: +b.dataset.addVariant, quantity: 1}])
        .then(open)
        .catch(err => { const s = b.parentNode.querySelector('.status'); if (s) s.textContent = err.message; else alert(err.message); })
        .finally(() => b.removeAttribute('aria-busy'));
    });

    return {open, add, refresh, items, hasSub};
  })();

  /* ---------- product configurator ---------- */
  function initProduct(){
    const dataEl = $('yProductData'), sizesEl = $('sizes');
    if (!dataEl || !sizesEl || sizesEl.dataset.ready) return;
    sizesEl.dataset.ready = '1';
    const D = JSON.parse(dataEl.textContent);
    const T = D.tin;
    const everyEl = $('every'), planSub = $('planSub');
    const sel = {
      size: Math.max(0, D.selected || 0),
      plan: planSub && planSub.checked && D.plans.length ? 'sub' : 'one',
      every: Math.max(0, D.plans.findIndex(p => p.selected)),
      addon: false
    };
    if (!D.plans.length && $('freqGroup')) $('freqGroup').hidden = true;
    if (!D.plans.length) sel.plan = 'one';
    if (sel.plan === 'one' && $('planOne')) $('planOne').checked = true;

    D.sizes.forEach((s, i) => {
      const d = document.createElement('div');
      d.className = 'choice';
      d.innerHTML = `<input type="radio" name="size" id="size${i}" value="${i}" ${i === sel.size ? 'checked' : ''} ${s.available ? '' : 'disabled'}>
        <label for="size${i}"><strong>${esc(s.label)}</strong><span class="p"></span><span class="s"></span></label>
        ${D.popular === i + 1 && D.popularText ? `<span class="tag">${esc(D.popularText)}</span>` : ''}`;
      sizesEl.appendChild(d);
    });
    if (D.sizes.length > 3) sizesEl.style.gridTemplateColumns = `repeat(${Math.min(D.sizes.length, 4)},1fr)`;
    if (everyEl){
      everyEl.innerHTML = D.plans.map((p, i) => `<option value="${i}" ${i === sel.every ? 'selected' : ''}>${esc(p.label)}</option>`).join('');
    }

    const plan = () => D.plans[sel.every];
    const subPrice = s => {
      const p = plan();
      if (p && p.id && s.plans[p.id] != null) return s.plans[p.id];
      return D.demo ? Math.round(s.price * .85) : s.price;
    };
    const tinNow = sub => T ? (sub && T.subPrice > 0 && T.subPrice < T.price ? T.subPrice : T.price) : 0;

    function render(){
      const sub = sel.plan === 'sub';
      sizesEl.querySelectorAll('label').forEach((l, i) => {
        const s = D.sizes[i], now = sub ? subPrice(s) : s.price;
        l.querySelector('.p').textContent = s.available ? money(now) : tr('soldOut');
        l.querySelector('.s').textContent = sub && now < s.price ? tr('savePercent', {percent: pct(s.price, now)}) : '';
      });
      const s = D.sizes[sel.size];
      const gum = sub ? subPrice(s) : s.price;
      const save = $('planSave');
      if (save){ const p = pct(s.price, subPrice(s)); save.hidden = p <= 0; save.textContent = tr('savePercent', {percent: p}); }
      if ($('everyRow')) $('everyRow').hidden = !sub;
      let addon = 0;
      if (T && $('addonPrice')){
        const now = tinNow(sub);
        const was = now < T.price ? T.price : (T.compare > now ? T.compare : 0);
        $('addonPrice').textContent = money(now);
        $('addonWas').textContent = was ? money(was) : '';
        $('addonWas').hidden = !was;
        $('addonSave').hidden = !was;
        $('addonSave').textContent = was ? tr('savePercent', {percent: pct(was, now)}) : '';
        $('addonNote').textContent = sub || !(T.subPrice > 0 && T.subPrice < T.price)
          ? tr('tinNote')
          : tr('tinNoteSubs', {price: money(T.subPrice)});
        addon = sel.addon ? now : 0;
      }
      $('totalToday').textContent = money(gum + addon);
      const buy = $('buyBtn');
      buy.disabled = !s.available;
      buy.textContent = !s.available ? tr('soldOut') : sub ? tr('subscribeNow') : tr('buyNow');
      $('fineprint').textContent = sub
        ? `${D.delivery || ''} ${tr('renews', {plan: plan() ? plan().label : '', price: money(gum)})}`.trim()
        : (D.delivery || '');
    }
    sizesEl.addEventListener('change', e => { sel.size = +e.target.value; render(); });
    document.querySelectorAll('input[name="plan"]').forEach(r => r.addEventListener('change', e => { sel.plan = e.target.value; render(); }));
    if (everyEl) everyEl.addEventListener('change', e => { sel.every = +e.target.value; render(); });
    if ($('addTin')) $('addTin').addEventListener('change', e => { sel.addon = e.target.checked; render(); });

    $('buyBtn').addEventListener('click', () => {
      const fine = $('fineprint');
      if (D.demo){
        fine.textContent = tr('preview');
        return;
      }
      const s = D.sizes[sel.size], sub = sel.plan === 'sub';
      const line = {id: s.id, quantity: 1};
      if (sub && plan() && plan().id) line.selling_plan = plan().id;
      const lines = [line];
      if (sel.addon && T && T.id && T.available && !Cart.items().some(i => i.variant_id === T.id)) lines.push({id: T.id, quantity: 1});
      const buy = $('buyBtn');
      buy.setAttribute('aria-busy', 'true');
      Cart.add(lines)
        .then(Cart.open)
        .catch(err => { fine.textContent = err.message; })
        .finally(() => buy.removeAttribute('aria-busy'));
    });
    render();
  }

  /* ---------- reviews: a centred carousel, side cards shrink and fade ---------- */
  function initReviews(){
    const revTrack = $('revTrack'), revCount = $('revCount'), revPrev = $('revPrev'), revNext = $('revNext');
    if (!revTrack || revTrack.dataset.ready) return;
    revTrack.dataset.ready = '1';
    const revCards = [...revTrack.querySelectorAll('.rev')];
    if (!revCards.length) return;
    const SHRINK = .16, DIM = .5;
    let revActive = -1;
    function revPaint(){
      const mid = revTrack.scrollLeft + revTrack.clientWidth / 2;
      let best = 0, bd = 1e9;
      revCards.forEach((c, i) => {
        const step = c.offsetWidth * 1.05;
        const d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid) / step;
        const t = Math.min(1, d);
        c.style.setProperty('--k', (1 - SHRINK * t).toFixed(3));
        c.style.setProperty('--o', (1 - DIM * t).toFixed(3));
        if (d < bd){ bd = d; best = i; }
      });
      if (best !== revActive){
        revActive = best;
        revCards.forEach((c, i) => c.classList.toggle('on', i === best));
        revCount.textContent = `${best + 1} / ${revCards.length}`;
        revPrev.disabled = best === 0;
        revNext.disabled = best === revCards.length - 1;
      }
    }
    function revGo(i, instant){
      i = Math.max(0, Math.min(revCards.length - 1, i));
      const c = revCards[i];
      revTrack.scrollTo({left: c.offsetLeft + c.offsetWidth / 2 - revTrack.clientWidth / 2, behavior: instant || reduce ? 'auto' : 'smooth'});
    }
    let revTick = false;
    revTrack.addEventListener('scroll', () => {
      if (!revTick){ requestAnimationFrame(() => { revPaint(); revTick = false; }); revTick = true; }
    }, {passive: true});
    revPrev.addEventListener('click', () => revGo(revActive - 1));
    revNext.addEventListener('click', () => revGo(revActive + 1));
    revTrack.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight'){ e.preventDefault(); revGo(revActive + 1); }
      if (e.key === 'ArrowLeft'){ e.preventDefault(); revGo(revActive - 1); }
    });
    // mouse: drag the row; click a side card to bring it to the middle
    let revMoved = false;
    if (window.matchMedia('(hover:hover) and (pointer:fine)').matches){
      let sx = 0, sl = 0, dragging = false;
      revTrack.addEventListener('pointerdown', e => {
        if (e.button !== 0 || e.pointerType !== 'mouse') return;
        dragging = true; revMoved = false; sx = e.clientX; sl = revTrack.scrollLeft;
      });
      window.addEventListener('pointermove', e => {
        if (!dragging) return;
        const dx = e.clientX - sx;
        if (!revMoved && Math.abs(dx) > 4){ revMoved = true; revTrack.style.scrollSnapType = 'none'; revTrack.classList.add('dragging'); }
        if (revMoved) revTrack.scrollLeft = sl - dx;
      });
      window.addEventListener('pointerup', () => {
        if (!dragging) return;
        dragging = false;
        if (revMoved){ revTrack.classList.remove('dragging'); revTrack.style.scrollSnapType = ''; revGo(revActive); }
      });
    }
    revTrack.addEventListener('click', e => {
      const c = e.target.closest('.rev');
      if (!c || revMoved) return;
      const i = revCards.indexOf(c);
      if (i !== revActive) revGo(i);
    });
    revResize = () => { if (!revTrack.isConnected) return; if (revActive > -1) revGo(revActive, true); revPaint(); };
    revGo(Math.min(1, revCards.length - 1), true);
    revPaint();
  }

  /* ---------- scroll cue ---------- */
  function initCue(){
    const cue = $('scrollcue');
    // the hero button is a real link (the page-wide link handler scrolls it); only the old arrow needs wiring
    if (!cue || cue.dataset.ready || cue.tagName === 'A') return;
    cue.dataset.ready = '1';
    cue.addEventListener('click', () => {
      const target = $('product') || (cue.closest('.shopify-section') || cue).nextElementSibling;
      if (target) scrollToEl(target);
    });
  }

  function initAll(){
    initMenus();
    initCue();
    initProduct();
    initReviews();
    buildMarquees();
    collectHands();
    layout();
  }

  initAll();
  Cart.refresh();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { buildMarquees(); layout(); });
  if (playIntro) runIntro();
  else if (intro) intro.classList.remove('on', 'boot');
  if (!reduce) requestAnimationFrame(animateHands);

  // theme editor: re-wire sections as they are added or changed
  document.addEventListener('shopify:section:load', initAll);
})();
